import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight } from "lucide-react";
import useSiteConfig from "@/hooks/useSiteConfig";

/**
 * Yellow banner shown at the top of AdminLayout when maintenance mode is ON,
 * so admins always know the public site is hidden.
 */
export default function MaintenanceBanner() {
  const config = useSiteConfig();
  if (!config?.maintenance_mode_enabled) return null;
  return (
    <div
      data-testid="admin-maintenance-banner"
      role="status"
      className="border-b border-amber-300 bg-amber-100/85 text-amber-900 px-5 py-2.5 flex items-center justify-between gap-3 text-sm"
    >
      <div className="flex items-center gap-2 min-w-0">
        <AlertTriangle className="h-4 w-4 shrink-0" strokeWidth={1.8} />
        <span className="font-medium">Maintenance mode is ON</span>
        <span className="text-amber-900/75 hidden sm:inline">— public visitors see the construction page.</span>
      </div>
      <Link
        to="/admin/settings"
        data-testid="admin-maintenance-banner-link"
        className="inline-flex items-center gap-1 text-amber-900 underline-offset-2 hover:underline whitespace-nowrap"
      >
        Turn off <ArrowRight className="h-3.5 w-3.5" strokeWidth={1.8} />
      </Link>
    </div>
  );
}
